export default __webpack_public_path__ + "static/media/2477.b18b70a5.png";